import * as React from 'react';
import styled from 'styled-components';
import get from 'lodash/get';

import { interaction } from '@origin-digital/reporting-client';
import { BREAK_POINTS } from '../../consts/style';
import { TRACKING_PREFIX } from '../../consts/config';

type TrustPilotProps = {
  paddingBottom?: boolean;
};

type ReviewsProps = {
  paddingBottom?: boolean;
};

const Rating = styled.div`
  margin-bottom: 16px;
`;

const Reviews = styled.div`
  width: 100%;
  max-width: 1108px;
  margin: 0 auto;
  ${(p: ReviewsProps) =>
    p.paddingBottom &&
    `
    padding-bottom: 24px;

    @media (min-width: ${BREAK_POINTS.MIN.LG}) {
      padding-bottom: 40px;
    }
  `}
`;

const trackHeading = () => {
  interaction('click', {
    appName: 'homepage',
    componentType: 'link',
    id: `${TRACKING_PREFIX}trustpilot-heading-widget`,
    label: 'Heading',
    parentContainer: 'trustpilot',
  });
};

const trackReview = () => {
  interaction('click', {
    appName: 'homepage',
    componentType: 'link',
    id: `${TRACKING_PREFIX}trustpilot-review-widget`,
    label: 'Review',
    parentContainer: 'trustpilot',
  });
};

const trackRating = () => {
  interaction('click', {
    appName: 'homepage',
    componentType: 'link',
    id: `${TRACKING_PREFIX}trustpilot-rating-widget`,
    label: 'Rating',
    parentContainer: 'trustpilot',
  });
};

const trackingFunctionMap = {
  'trustpilot-heading-widget': trackHeading,
  'trustpilot-rating-widget': trackRating,
  'trustpilot-reviews-widget': trackReview,
};

export const TrustPilot = ({ paddingBottom }: TrustPilotProps) => {
  React.useEffect(() => {
    const intervals = () => {
      const elem = document.activeElement;
      if (elem && elem.tagName === 'IFRAME') {
        const id = get(elem.parentElement, 'id') || '';

        const tracker = trackingFunctionMap[id];
        if (tracker) {
          tracker();
        }
        clearInterval(monitor);
        monitor = setInterval(exitIframe.bind(null, elem), 100);
      }
    };

    const exitIframe = (iframe) => {
      const elem = document.activeElement;
      if ((elem && elem.tagName !== 'IFRAME') || (elem && elem !== iframe)) {
        clearInterval(monitor);
        monitor = setInterval(intervals, 100);
      }
    };

    let monitor = setInterval(intervals, 100);

    return () => {
      clearInterval(monitor);
    };
  }, []);

  return (
    <div data-id="trustpilot-container">
      <Rating
        id="trustpilot-heading-widget"
        className="trustpilot-widget"
        data-locale="en-AU"
        data-template-id="53aa8807dec7e10d38f59f32"
        data-businessunit-id="5c4071dd98758b0001825697"
        data-style-height="150px"
        data-style-width="100%"
        data-theme="light"
        data-text-color="#505050"
        title="Trustpilot Rating Widget"
        onClick={trackRating}
      >
        <a
          href="https://au.trustpilot.com/review/www.originenergy.com.au"
          target="_blank"
          rel="noopener"
        />
      </Rating>

      <Reviews
        id="trustpilot-reviews-widget"
        className="trustpilot-widget"
        data-locale="en-AU"
        data-template-id="54ad5defc6454f065c28af8b"
        data-businessunit-id="5c4071dd98758b0001825697"
        data-style-height="180px"
        data-style-width="100%"
        data-theme="light"
        data-stars="5"
        data-tags="Customer-Service"
        data-review-languages="en"
        data-text-color="#505050"
        onClick={trackReview}
        title="Trustpilot Reviews Widget"
        paddingBottom={paddingBottom}
      >
        <a
          href="https://au.trustpilot.com/review/www.originenergy.com.au"
          target="_blank"
          rel="noopener"
        />
      </Reviews>
    </div>
  );
};
